// @ts-nocheck
class RUPhone {
    constructor(input) {
        this.el = input;
        this.init();
    }

    init() {
        this.el.placeholder = "+7 (___) ___-__-__";
        this.el.autocomplete = "tel";

        this.el.addEventListener("input", e => this.handleInput(e));
        this.el.addEventListener("paste", e => this.handlePaste(e));

        // обработка автозаполнения браузером
        requestAnimationFrame(() => this.format());
    }

    digits(v) {
        return v.replace(/\D/g, "");
    }

    normalize(d) {
        if (!d) return "";

        if (d[0] === "8") d = "7" + d.slice(1);
        if (d[0] !== "7") d = "7" + d;

        return d.slice(0, 11);
    }

    format() {
        let d = this.normalize(this.digits(this.el.value));
        if (!d) return (this.el.value = "");

        let out = "+7";
        let n = d.slice(1);

        if (n.length) out += " (" + n.slice(0, 3);
        if (n.length >= 3) out += ")";
        if (n.length > 3) out += " " + n.slice(3, 6);
        if (n.length > 6) out += "-" + n.slice(6, 8);
        if (n.length > 8) out += "-" + n.slice(8, 10);

        this.el.value = out;
    }

    handleInput() {
        const pos = this.el.selectionStart;
        this.format();
        this.el.setSelectionRange(this.el.value.length, this.el.value.length);
    }

    handlePaste(e) {
        e.preventDefault();
        const text = e.clipboardData.getData("text");
        this.el.value = text;
        this.format();
    }

    // === публичные методы ===

    getRaw() {
        return this.normalize(this.digits(this.el.value));
    }

    getValue() {
        const d = this.getRaw();
        return d ? "+" + d : "";
    }

    isValid() {
        return this.getRaw().length === 11;
    }
}

$(function () {
    const $callbackForm = $('.form.callback')

    if (!$callbackForm.length) {
        return;
    }

    $callbackForm.each(function () {
            const $form = $(this);
            const $contact = $form.find('.contact');

            if (!$contact.length) return;

            const phone = new RUPhone($contact.get(0));

            // сохраняем экземпляр
            $form.data('phoneInstance', phone);
        }
    )

    const $contact = $callbackForm.find('.contact')

    const $btn = $callbackForm.find('button.send')

    $btn.on('click', (event) => {

        const $thisBtn = $(event.target)
        const $thisForm = $thisBtn.closest('.form.callback')

        const $success = $thisForm.find('.success')
        const $error = $thisForm.find('.error')

        const showError = (message) => {
            $error.text(message).removeClass('d-none')
        }

        $success.addClass('d-none')
        $error.addClass('d-none')

        const $username = $thisForm.find('.username')
        const username = $username.val()
        const $contact = $thisForm.find('.contact')
        const contact = $contact.val()
        const $message = $thisForm.find('.question')
        const message = $message.val()
        const phone = $thisForm.data('phoneInstance');

        if (!phone.isValid()) {
            showError('Указан некорректный номер')
            return
        }

        if (!contact || contact.length < 10) {
            showError('Не указаны контактные данные')
            return
        }

        // if (!message) {
        //     showError('Не указано сообщение')
        //     return
        // }

        $thisBtn.attr('disabled', 'disabled')

        window.ym && ym(48753395, 'reachGoal', 'send-message')

        $.post(window.wpConfig.ajaxUrl, {
            action: 'contact_form',
            data: {
                contact,
                message,
                username
            }
        })
            .done(function (data) {
                if (!data.success) {
                    showError(data.message)
                    return
                }
                $success.removeClass('d-none')
                $message.val('')
                $contact.val('')
                $username.val('')
            })
            .fail(function (xhr) {
                showError(xhr.responseText)
            })
            .always(function () {
                $thisBtn.removeAttr('disabled')
            });
    })


})

